// ── Localhost bypass ──────────────────────────────────────────────────────────
export function isLocalhost(): boolean {
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1' || h === '::1';
}
